<template>
  <div class="d-center-between flex-wrap pt-3 pb-3">
    <div class="w-40 mb-2 d-start-start text-left"><left-text leftText="单位名称"/>
      <label>
        <span class="mr-3">{{StoreBasicInfo.title}} </span>
        <span class="text-link h6" @click="goFinancialDetail">查看资金流水</span>
      </label>
    </div>
    <div class="w-40 mb-2 d-center-start" >
      <left-text leftText="负责人数"/>
      <el-popover placement="top-start" trigger="hover" v-if="highLevelUser.length>0">
        <span class="text-link" slot="reference" @click="$emit('showUserArr')">{{highLevelUser.length}}人</span>
        <p v-for="item in highLevelUser" :key="item.id">
          <i class="iconfont icon-weixin1 mr-1" :class="[item.wechat_openid ? 'text-success' : 'text-muted']"></i>
          {{item.truename}} {{item.name}} {{item.mobile}}
        </p>
      </el-popover>
      <span v-else>无</span>
    </div>
    <div class="w-40 mb-2 d-center-start"><left-text :leftText="confirm==1?'提交时间':'注册时间'"/>{{StoreBasicInfo.time | formatTimestamp(1)}}</div>
    <div class="w-40 mb-2 d-center-start"><left-text leftText="认证状态"/>
      <span :class="[StoreBasicInfo.verify===1?'text-success':'text-danger']">{{StoreBasicInfo.verify | formatVar('verifyType')}}</span>
    </div>
    <div class="mb-2 d-start-start text-left w-40"><left-text leftText="单位地址"/>
      {{StoreBasicInfo.province_name}}省{{StoreBasicInfo.city_name}}市{{StoreBasicInfo.district_name}}{{StoreBasicInfo.address}}
       <i class="el-icon-location location" v-if="storeInfo.type==3&&StoreBasicInfo.longitude" @click="mapclock(StoreBasicInfo.longitude,StoreBasicInfo.latitude,StoreBasicInfo.title)"></i>
    </div>
    <div class="w-40 mb-2 d-center-start" v-if="StoreBasicInfo.group_name&&storeInfo.type==3"><left-text leftText="所属集团"/>{{StoreBasicInfo.group_name}}</div>
     <!--周边交通-->
    <surrounding-traffic id="tabMapInfo" :DisplayBasicInfo='DisplayBasicInfo' v-if="map"/>
  </div>
</template>

<script>
  import {mapState,mapGetters} from 'vuex'
  import SurroundingTraffic from './SurroundingTraffic'
  export default {
    name: 'BaseInfo',
    data() {
      return {
        DisplayBasicInfo:{
          longitude:'',
          latitude:''
        },
        map:false
      }
    },
    computed:{
      ...mapState(['StoreBasicInfo']),
      ...mapGetters(['storeInfo','isAdmin','isGroup']),
      // 只返回 level > 2 的用户
      highLevelUser() {
        return this.StoreBasicInfo.userArr.filter(item => item.level > 2);
      }
    },
    components:{SurroundingTraffic},
    props:{
      confirm:{}
    },
    mounted(){
      console.log(this.StoreBasicInfo)
    },
    methods:{
      mapclock(longitude,latitude,title){
        let Display={
          longitude:longitude,
          latitude:latitude,
          title:title
        }
        this.map=!this.map;
        this.DisplayBasicInfo=Display;
      },
      goFinancialDetail() {
        let adminQuery = {
          type:'1',
          storeType:this.storeInfo.type,
          storeId:this.storeInfo.storeId,
          // storeName:this.StoreBasicInfo.title
        },groupQuery = {
          store:this.storeInfo.storeId,
          GST:this.StoreBasicInfo.title,
        };
        //FinancialLists-FinancialList
        this.$router.push({
          name:this.isAdmin ? 'PaymentRecordList' : 'StoreList',
          query:this.isAdmin ? adminQuery : groupQuery,
        })
      }
    }
  }
</script>
<style scoped>
  .location{
    font-size: 20px;
    color: var(--smtc-color-primary); 
    margin-left: 6px;
    cursor: pointer;
  }
</style>